module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURUxpcV9uhGJvhl9vhF9tgl5ug19ug15ugm57mF9tg19ug15tg2Z1h15ug19uhF5vg2FwhV5ug15tguNKCl8AAAASdFJOUwBwHEKHr5zkB7/37hDPUF0v2p6MLeAAAACVSURBVDjLrdRBEoQgDETRKCJqhEDuf9gBZ+li/lSR9dukkm6R99SWgpA53a8AIZP16lIrkAHLMmRaiezQG5H2yBvIZciM5XkAuf0nI5H7kLtMlXHIDcCDy/FKvmBp/arJyRRhzhOHpsTp72SsjSWIujt/V2bOpp0FO/oQ1NGnfVycFywaVVoT1BmtMqXlqNBJ0fyu5Q9HUhdCe68k8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/back_android.png
// module id = 600
// module chunks = 0